import { createContext } from 'react';

const initialContext = {};

const navBookmarkContext = createContext<Record<string, string>>(initialContext);

export { navBookmarkContext };
